import React from 'react'
import { Menu } from 'antd';
import { HasPermission } from 'xadmin-auth';
import RenderSetting from './RenderSetting';
import SystemOperation from './SystemOperation';
import { StoreWrap, app, api } from 'xadmin';
import { Icon } from 'xadmin-ui';
import { use, config } from 'xadmin';
import { effects } from 'redux-saga'
const { all, put, select, takeEvery } = effects

const handle_get_settings = function* () {
  const settings = yield api({ name: 'core/setting' }).fetch('').then(({ json }) => json)
  yield put({ type: '@@iot/SAVE_SETTINGS', payload: settings, success: true })
}

const handle_save_settings = function* ({ payload }) {
  const { _t } = app.context
  const settings = yield api({ name: 'core/setting' }).save(payload)
  yield put({ type: '@@iot/SAVE_SETTINGS', payload: settings, success: true })

  yield put({
    type: '@@xadmin/ADD_NOTICE', payload: {
      type: 'success', headline: _t('Success'), message: '系统设置保存成功'
    }
  })
}

const SiteTitle = props => {
  const { settings } = use('settings')
  return <h4 className="Settings-title" dangerouslySetInnerHTML={{ __html: settings && settings['name'] }} />
}

const SiteCopyright = props => {
  const { settings } = use('settings')
  return <>{settings && settings['copyright']}</>
}

const SiteLogo = props => {
  const { settings } = use('settings')
  const logo = settings && settings['logo']
  return logo ? <img src={logo} alt="logo" onClick={() => app.go('/app/dashboard')} /> : null
}

const createStyleElement = url => {
  // console.log(config('mediaUrl'))
  const style = document.createElement('style')

  style.type = 'text/css'
  style.innerHTML = `.setGuideCard{ background:url('${url}') no-repeat;  background-size: 100% 100%; }`
  document.getElementsByTagName('HEAD').item(0).appendChild(style)
}
const createTabIconElement = url => {
  const link = document.createElement('link')
  link.setAttribute("rel", "icon");
  link.setAttribute("type", "image/x-icon");
  link.setAttribute("href", url)
  let heads = document.getElementsByTagName("head")
  if (heads.length) heads[0].appendChild(link)
}

export default {
  name: 'iot.system',
  items: {
    'systemOperation': { type: 'array' }
  },
  context: app => (context, cb) => {
    const { store } = context
    const storeState = store?.getState()
    const isLogin = Boolean(storeState?.user?.token)

    api({ name: `core/setting${isLogin ? '' : '/part'}` }).fetch('')
      .then(({ json: settings }) => {
        store.dispatch({ type: '@@iot/SAVE_SETTINGS', payload: settings, success: true })
        settings.backgroundImage && createStyleElement(settings.backgroundImage)
        settings.logo && createTabIconElement(settings.logo)
        document.title = (settings?.reception_name || 'Air IoT物联网平台').replace(/<[^>]*>/ig, "")
        cb(null, { ...context, settings })
      })
      .catch(cb)
  },
  config: {
    'site.title': <SiteTitle />,
    'site.logo': <SiteLogo />,
    'site.copyright': <SiteCopyright />
  },
  hooks: {
    'settings': props => {
      const { settings, dispatch } = use('redux', state => ({ settings: state.settings }))

      const getSettings = () => {
        dispatch({ type: '@@iot/GET_SETTINGS' })
      }

      const saveSettings = (value) => {
        dispatch({ type: '@@iot/SAVE_SETTINGS', payload: value })
      }

      return { ...props, settings, getSettings, saveSettings }
    }
  },
  mappers: {
    'system.settings': {
      data: ({ state }) => ({ settings: state.settings }),
      method: {
        getSettings: ({ dispatch }) => () => {
          dispatch({ type: '@@iot/GET_SETTINGS' })
        },
        saveSettings: ({ dispatch }) => (value) => {
          dispatch({ type: '@@iot/SAVE_SETTINGS', payload: value })
        }
      }
    }
  },
  effects: (app) => function* () {
    yield all([
      takeEvery(action => action.type == '@@iot/GET_SETTINGS', handle_get_settings),
      takeEvery(action => action.type == '@@iot/SAVE_SETTINGS' && !action.success, handle_save_settings)
    ])
  },
  reducers: {
    settings: (state = {}, { type, payload, success }) => {
      if (type == '@@iot/SAVE_SETTINGS' && payload && success) {
        return { ...state, ...payload }
      }
      return state
    }
  },
  menuItems: [
    { title: '系统操作', url: '/app/operation', icon: '系统操作', permission: 'operation.edit' }
  ],
  routers: {
    '/app/': [
      {
        path: 'operation',
        component: SystemOperation
      }
    ]
  }
}
